import {AbstractControl, ValidatorFn} from '@angular/forms';

export class CustomValidators {

  static notBlank(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = control.value;
      if (value && value.length !== 0 && value.trim().length === 0) {
        return {required: true};
      }
      return null;
    };
  }
}
